export default __webpack_public_path__ + "static/media/header-facebook.e5abf9e3.png";